import { render } from "./AddToCartSearch.vue?vue&type=template&id=746b86c5"
import script from "./AddToCartSearch.vue?vue&type=script&lang=js"
export * from "./AddToCartSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__